import { UserPlanVo, UserProfile } from "@/api";
import { Button } from "@/component/Button";
import Link from "next/link";
import React from "react";
import { CreditPlanLink } from "./CreditPlanLink";

interface AuthActionsProps {
  userLoading: boolean;
  user: UserProfile | null;
  userPlan: UserPlanVo | null;
  userCredits: number;
}

export const AuthActions: React.FC<AuthActionsProps> = ({
  userLoading,
  user,
  userPlan,
  userCredits,
}) => (
  <>
    <div className="hidden sm:block">
      <CreditPlanLink
        user={user}
        userLoading={userLoading}
        userPlan={userPlan}
        userCredits={userCredits}
      />
    </div>
    <Link href="/login">
      <Button className="!h-[40px] !px-4 sm:!px-6 !text-sm" type="primary">
        Sign In
      </Button>
    </Link>
  </>
);
